import { Loader } from '@anex/common';
import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AlertContainer, Error } from '../../../../components';
import { ContractInfo } from './components/ContractInfo';
import { SuccessInfo } from './components/SuccessInfo';
import { Disclaimer } from './components/Disclaimer';
var SelectPlanIspxForm = observer(function (props) {
    var checkAddressStore = props.checkAddressStore, planStore = props.planStore, setFieldValue = props.setFieldValue, errors = props.errors, values = props.values, touched = props.touched;
    var contractCode = values.contractCode, voipCode = values.voipCode;
    var _a = React.useState([]), planOption = _a[0], setPlanOptions = _a[1];
    var _b = React.useState([]), plans = _b[0], setPlans = _b[1];
    React.useEffect(function () {
        processPlanDetails();
        props.saleStore.setVoucher(null);
    }, []);
    React.useEffect(function () {
        props.summaryStore.getSummary(contractCode, props.summaryStore.hardwareCode, props.checkAddressStore.nbnLocId, voipCode, null);
    }, [contractCode, voipCode]);
    React.useEffect(function () {
        if (checkAddressStore.qualificationResponse) {
            processPlanDetails();
        }
    }, [checkAddressStore.qualificationResponse]);
    React.useEffect(function () {
        if (checkAddressStore.sqAddressResponse) {
            checkAddressStore.loading = true;
            processPlanDetails();
            checkAddressStore.loading = false;
        }
    }, [checkAddressStore.upgardeSelected]);
    function handlecContractCodeChange(code) {
        planStore.setPlanByType(values.planType, code);
        setFieldValue('contractCode', code);
    }
    function handleValueChange(e) {
        if (e.target.name === 'existingNumber') {
            setFieldValue('existingNumber', JSON.parse(e.target.value));
        }
        else {
            setFieldValue(e.target.name, e.target.value);
        }
    }
    function handleBooleanChange(e) {
        setFieldValue(e.target.name, e.target.checked);
        if (e.target.name === 'includeVoipBundle' && !e.target.checked) {
            setFieldValue('voipCode', '');
        }
    }
    function convertToMpbs(kbps) {
        return kbps / 1024;
    }
    function processPlanDetails() {
        var planCode = planStore.planCode;
        var allPlans = planStore.getPlans();
        var options = Array.from(new Set(allPlans.filter(function (p) { return p.planType !== null; }).map(function (p) { return p.planType; })));
        setPlanOptions(options.sort(function (a, b) { return (b < a ? -1 : 1); }));
        if (checkAddressStore.upgardeSelected) {
            console.log('upgrade processing');
            var minimumDownloadSpeed = checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails.minimumDownloadSpeed;
            var minimumUploadSpeed = checkAddressStore.sqAddressResponse.sqSummary.nbn
                .alternativeTechnologyDetails.minimumUploadSpeed;
            if (minimumDownloadSpeed != null && minimumUploadSpeed != null) {
                var filterPlans = allPlans.filter(function (p) {
                    return p.baseSpeedInKb >= minimumDownloadSpeed * 1024 &&
                        p.baseSpeedOutKb >= minimumUploadSpeed * 1024;
                });
                console.log('filterPlans', filterPlans);
                setPlans(filterPlans);
            }
            else
                setPlans(allPlans);
        }
        else {
            var maxDownloadSpeed = checkAddressStore.maximumDownloadSpeed;
            var maxUploadSpeed = checkAddressStore.maximumUploadSpeed;
            if (maxDownloadSpeed != null && maxUploadSpeed != null) {
                var filterPlans = allPlans.filter(function (p) {
                    return p.baseSpeedInKb <= maxDownloadSpeed &&
                        p.baseSpeedOutKb <= maxUploadSpeed;
                });
                console.log('filterPlans', filterPlans);
                setPlans(filterPlans);
            }
            else if (maxDownloadSpeed != null && maxUploadSpeed == null) {
                var filterPlans = allPlans.filter(function (p) { return p.baseSpeedInKb <= maxDownloadSpeed; });
                setPlans(filterPlans);
            }
            else
                setPlans(allPlans);
        }
        if (planCode && !values['contractCode']) {
            var selectedPlan = allPlans.find(function (p) { return p.code === planCode; });
            if (selectedPlan) {
                var typePlan = selectedPlan.planType;
                setFieldValue('planType', typePlan);
                setFieldValue('contractCode', planCode);
                planStore.setPlanByType(typePlan, planCode);
                if (typePlan === 'Business') {
                    setFieldValue('voipCode', 'V-1');
                }
            }
            else {
                setFieldValue('planType', 'Personal');
            }
        }
        else if (!planCode) {
            setFieldValue('planType', 'Personal');
        }
    }
    function handleOrderTypeChange(value) {
        planStore.setDetailsFromForm({ nbnOrderType: value });
    }
    return (React.createElement(Form, null,
        React.createElement(Loader, { loading: checkAddressStore.loading, text: "Please wait, processing your upgrade request.." }),
        React.createElement(SuccessInfo, null),
        React.createElement("hr", null),
        React.createElement(AlertContainer, null),
        planStore.plans !== null && (React.createElement(React.Fragment, null,
            React.createElement(Error, { name: "planType" }),
            React.createElement("div", { className: "tabs row" + (errors.planType && touched.planType ? ' error' : '') }, planOption.map(function (type) { return (React.createElement("div", { className: "tab-item col-sm" },
                React.createElement("div", { className: "select-tab" + (values.planType === type ? ' selected' : ''), onClick: function () {
                        setFieldValue('planType', type);
                        setFieldValue('contractCode', planStore.selectedPlanByType[type]);
                        if (type === 'Business') {
                            setFieldValue('includeVoipBundle', false);
                            setFieldValue('voipCode', 'V-1');
                        }
                        else {
                            setFieldValue('voipCode', '');
                        }
                    } }, type))); })),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "stacks" + (errors.contractCode && touched.contractCode ? ' error' : '') }, plans
                        .filter(function (plan) { return plan.planType === values.planType; })
                        .sort(function (a, b) { return a.baseSpeedInKb - b.baseSpeedInKb; })
                        .sort(function (a, b) {
                        return a.currentPricing.sellInc - b.currentPricing.sellInc;
                    })
                        .map(function (p) { return (React.createElement("div", { key: p.code, className: "card " + (planStore.selectedPlanByType[values.planType] === p.code
                            ? 'active'
                            : ''), onClick: function () {
                            if (values.contractCode === p.code) {
                                handlecContractCodeChange('');
                            }
                            else {
                                handlecContractCodeChange(p.code);
                            }
                        } },
                        React.createElement("div", { className: "card-header" },
                            React.createElement("h5", null, p.name),
                            React.createElement("p", null,
                                React.createElement("strong", null,
                                    "$",
                                    (p.currentPricing.sellInc / 100).toFixed(0)),
                                "/",
                                p.billingInterval.toLowerCase()),
                            React.createElement("p", null,
                                "Speed: ",
                                convertToMpbs(p.baseSpeedInKb),
                                "/",
                                convertToMpbs(p.baseSpeedOutKb),
                                " Mbps")),
                        React.createElement("div", { className: "card-body" },
                            React.createElement(ContractInfo, { plan: p })))); })))),
            React.createElement(Error, { name: "contractCode" }),
            React.createElement(Disclaimer, { wholesaler: "Coles" }),
            values.planType === 'Business' && values.contractCode && (React.createElement(React.Fragment, null,
                React.createElement("br", null),
                React.createElement(ExistingNumber, { values: values, errors: errors, touched: touched, handleChange: handleValueChange }))),
            values.planType === 'Personal' && values.contractCode && (React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-12" },
                    React.createElement("label", { htmlFor: "includeVoipBundle", className: "checkbox checkbox-square" },
                        React.createElement(Field, { id: "includeVoipBundle", name: "includeVoipBundle", type: "checkbox", checked: values.includeVoipBundle, onChange: handleBooleanChange }),
                        React.createElement("small", { className: "label voip-label" },
                            "I would like to add voice to my nbn",
                            React.createElement("sup", null, "TM"),
                            " plan")),
                    values.includeVoipBundle && (React.createElement("div", { className: "pl-md-5" },
                        React.createElement("a", { href: "/pdf/international-call-rates.pdf", target: "_blank" }, "Detailed call rates"),
                        React.createElement("br", null),
                        React.createElement("div", { className: "voip-plans" + (errors.voipCode && touched.voipCode ? ' error' : '') },
                            planStore
                                .eligibleVoipPlans(values.contractCode)
                                .map(function (plan) { return (React.createElement("label", { htmlFor: plan.code.toString(), className: "checkbox", key: plan.code },
                                React.createElement(Field, { key: plan.code, type: "radio", name: "voipCode", id: plan.code, value: plan.code, checked: values.voipCode === plan.code }),
                                React.createElement("small", { className: "label" },
                                    plan.name + ' ',
                                    React.createElement("span", { className: "voip-price" },
                                        "$",
                                        (plan.currentPricing.sellInc / 100).toFixed(2))),
                                React.createElement("p", { className: "voip-description" }, plan.description))); }),
                            React.createElement(Error, { name: "voipCode" })),
                        React.createElement(ExistingNumber, { values: values, errors: errors, touched: touched, handleChange: handleValueChange })))))))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
var Waiver = function (_a) {
    var acceptWaiver = _a.acceptWaiver;
    return (React.createElement("div", { className: "waiver" },
        React.createElement("h4", null, "Customer service guarantee waiver"),
        React.createElement("p", null,
            React.createElement("small", null, "The Coles voice service is supplied over the Voice Over Internet Protocol (VOIP). This differs from traditional voice services supplied over copper from other service companies, one of which is the low price.")),
        React.createElement("p", null,
            React.createElement("small", null, "Due to these differences, we require you to waive your rights under the Customer Service Guarantee (known as the \"CSG\").")),
        React.createElement("p", null,
            React.createElement("small", null, "The CSG obliges service providers to meet certain timeframes for service connection, fault rectification and the attendance of appointments. It also requires that written information about the CSG be provided to customers at least once every two years. Compensation is payable for failure to meet these performance standards.")),
        React.createElement("p", null,
            React.createElement("small", null, "Agreeing to this waiver means that you will not be entitled to compensation if we fail to meet the CSG performance standards.")),
        React.createElement("p", null,
            React.createElement("small", null, "You are under no obligation to agree to the waiver and you may withdraw your consent at any time within the 5-working day period from the time you received this email by contacting us. However, if you do not agree to the waiver we are unable to supply you with a voice service.")),
        React.createElement("p", null,
            React.createElement("small", null, "If you do not agree to this waiver, please email support@osu-ispx.anex.com.au or call us on 1300 017 150 and mention that you do not wish to agree to this waiver and withdraw the application.")),
        React.createElement("label", { htmlFor: "voipCsgWaiverAccepted", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "voipCsgWaiverAccepted", name: "voipCsgWaiverAccepted", type: "checkbox", checked: acceptWaiver }),
            React.createElement("small", { className: "label label-waiver" }, "I agree to the above waiver, understand the consequences of consenting to the waiver; and hereby give my consent")),
        React.createElement(Error, { name: "voipCsgWaiverAccepted" })));
};
var ExistingNumber = function (_a) {
    var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "voip-label" }, "Would you like to keep your existing number?"),
        React.createElement("label", { htmlFor: "keepVoipNumber", className: "checkbox" },
            React.createElement(Field, { id: "keepVoipNumber", type: "radio", name: "existingNumber", value: "true", onChange: handleChange, checked: values.existingNumber === true }),
            React.createElement("small", { className: "label" }, "Yes, I would like to keep my existing number")),
        values.existingNumber && (React.createElement("div", { className: "pl-md-5" },
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "numberToPort" }, "Existing phone number with area code"),
                React.createElement(Field, { id: "numberToPort", name: "numberToPort", component: "input", className: "form-control shadow-alt " + (errors.numberToPort &&
                        touched.numberToPort &&
                        'error'), onChange: handleChange, value: values.numberToPort }),
                React.createElement(Error, { name: "numberToPort" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "fullName" },
                    "Full name",
                    ' ',
                    React.createElement("small", null, "(as it appears on your current phone provider's account)")),
                React.createElement(Field, { id: "fullName", name: "fullName", component: "input", className: "form-control shadow-alt " + (errors.fullName &&
                        touched.fullName &&
                        'error'), onChange: handleChange, value: values.fullName }),
                React.createElement(Error, { name: "fullName" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "address" },
                    "Address",
                    ' ',
                    React.createElement("small", null, "(as it appears on your current phone provider's account)")),
                React.createElement(Field, { id: "address", name: "address", component: "input", className: "form-control shadow-alt " + (errors.address &&
                        touched.address &&
                        'error'), onChange: handleChange, value: values.address }),
                React.createElement(Error, { name: "address" })),
            React.createElement("div", { className: "form-group" },
                React.createElement("label", { htmlFor: "accountNumber" }, "Account number with your current phone provider"),
                React.createElement(Field, { id: "accountNumber", name: "accountNumber", component: "input", className: "form-control shadow-alt " + (errors.accountNumber &&
                        touched.accountNumber &&
                        'error'), onChange: handleChange, value: values.accountNumber }),
                React.createElement(Error, { name: "accountNumber" })),
            React.createElement(Waiver, { acceptWaiver: values.voipCsgWaiverAccepted }))),
        React.createElement("label", { htmlFor: "newVoipNumber", className: "checkbox" },
            React.createElement(Field, { id: "newVoipNumber", type: "radio", name: "existingNumber", value: "false", onChange: handleChange, checked: values.existingNumber === false }),
            React.createElement("small", { className: "label" }, "No, I would like a new number")),
        React.createElement(Error, { name: "existingNumber" }),
        !values.existingNumber && (React.createElement("div", { className: "pl-md-5" },
            React.createElement(Waiver, { acceptWaiver: values.voipCsgWaiverAccepted })))));
};
export var SelectPlanIspx = inject('appStore', 'summaryStore', 'checkAddressStore', 'saleStore', 'planStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.planStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var planStore = _a.planStore;
        return planStore.planDetails.formValues
            ? planStore.planDetails.formValues
            : planStore.planDetails.formInitialValues;
    },
    validate: function (values) {
        var errors = {};
        var hasSpaces = /^\s.*|.+\s$/;
        var isPhone = /^0(2|3|7|8)[0-9]{8}$/;
        function checkForSpaces(name) {
            if (hasSpaces.test(values[name])) {
                errors[name] = "Start/end of value must not contain spaces";
            }
        }
        function hasvoipCode() {
            if (values.existingNumber) {
                if (values.numberToPort.match(isPhone) == null) {
                    errors.numberToPort = 'Please enter a valid Australian phone number';
                }
                if (!values.numberToPort) {
                    errors.numberToPort = 'Please enter your phone number';
                }
                else {
                    checkForSpaces('numberToPort');
                }
                if (!values.fullName) {
                    errors.fullName = 'Please enter your full name';
                }
                else {
                    checkForSpaces('fullName');
                }
                if (!values.address) {
                    errors.address = 'Please enter your address';
                }
                else {
                    checkForSpaces('address');
                }
                if (!/^[0-9]+$/.test(values.accountNumber)) {
                    errors.accountNumber = 'Please enter a valid account number';
                }
                if (!values.accountNumber) {
                    errors.accountNumber = 'Please enter your account number';
                }
                else {
                    checkForSpaces('accountNumber');
                }
            }
            if (!values.voipCsgWaiverAccepted) {
                errors.voipCsgWaiverAccepted = 'You must agree to the waiver';
            }
        }
        if (!values.planType) {
            errors.planType = 'Please select a plan type';
        }
        else {
            if (!values.contractCode) {
                errors.contractCode = 'Please select a contract';
            }
        }
        if (values.planType === 'Personal') {
            if (values.includeVoipBundle) {
                if (!values.voipCode) {
                    errors.voipCode = 'You must select a voip package';
                }
                hasvoipCode();
            }
        }
        if (values.planType === 'Business') {
            hasvoipCode();
        }
        return errors;
    },
})(SelectPlanIspxForm));
//# sourceMappingURL=SelectPlanISPX.js.map